module.exports = __webpack_public_path__ + "img/QA.927f6b80.svg";